module.exports = __webpack_public_path__ + "static/media/img_p1.b2c28c02.png";